module.exports = __webpack_public_path__ + "components/weather-icon/static/nightmodsnow@2-05b4dcf2d09e629ef2a44ceb651f1b9e.png";